import { useEffect } from 'react';
import { absUrl, DEFAULT_IMAGE, SITE_NAME } from '../seo/site';

const HEAD = () => document.head;

const upsertMeta = (attr, key, content) => {
  let el = HEAD().querySelector(`meta[${attr}="${key}"]`);
  if (content == null || content === '') {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    HEAD().appendChild(el);
  }
  el.setAttribute('content', content);
};

const upsertLink = (rel, href) => {
  let el = HEAD().querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    HEAD().appendChild(el);
  }
  el.setAttribute('href', href);
};

const isProductionHost = () => /(^|\.)gastro-beratung\.de$/.test(window.location.hostname);

export const applySeo = (seo) => {
  const { title, description, path, image = DEFAULT_IMAGE, type = 'website', noindex = false, jsonLd = [], publishedTime, modifiedTime, section } = seo;
  const url = absUrl(path || window.location.pathname);
  const robots = noindex || !isProductionHost() ? 'noindex, nofollow' : 'index, follow, max-image-preview:large, max-snippet:-1';

  document.title = title;
  upsertMeta('name', 'description', description);
  upsertMeta('name', 'robots', robots);
  upsertLink('canonical', url);

  upsertMeta('property', 'og:type', type);
  upsertMeta('property', 'og:site_name', SITE_NAME);
  upsertMeta('property', 'og:locale', 'de_DE');
  upsertMeta('property', 'og:title', title);
  upsertMeta('property', 'og:description', description);
  upsertMeta('property', 'og:url', url);
  upsertMeta('property', 'og:image', image);
  upsertMeta('property', 'og:image:width', '1200');
  upsertMeta('property', 'og:image:height', '630');
  upsertMeta('property', 'article:published_time', type === 'article' ? publishedTime : null);
  upsertMeta('property', 'article:modified_time', type === 'article' ? modifiedTime : null);
  upsertMeta('property', 'article:section', type === 'article' ? section : null);

  upsertMeta('name', 'twitter:card', 'summary_large_image');
  upsertMeta('name', 'twitter:title', title);
  upsertMeta('name', 'twitter:description', description);
  upsertMeta('name', 'twitter:image', image);

  HEAD().querySelectorAll('script[data-seo-jsonld]').forEach((el) => el.remove());
  jsonLd.forEach((data, i) => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-seo-jsonld', String(i));
    script.text = JSON.stringify(data);
    HEAD().appendChild(script);
  });
};

export const useSeo = (seo) => {
  const key = JSON.stringify(seo);
  useEffect(() => {
    applySeo(seo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
};
